/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-panel-left.html';

export default defineComponent({
  name: 'SetupPanelLeft',
  template,
  emits: {},
  props: {}
});
